import { useCallback, useEffect, useMemo, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useLocation, useNavigate } from "react-router-dom";
import { useMakeappointmentMutation } from "../State/Api/MakeAppointmentApiSlice";
import { useGetdropdowndataQuery, useLazyGetallappointmentsQuery } from "../State/Api/GetallappointmentsApiSlice";
import interactionPlugin from "@fullcalendar/interaction";
import AddAppointmentModal from "./ClinicModal/AddAppointmentModal";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import AvailableDoctors from "./AvailableDoctors";
import { ToastContainer, toast } from 'react-toastify';
import { useLazyGetavailabledoctorsQuery } from "../State/Api/AdddocApiSlice";

function AddAppointment() {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [displayDate, setDisplayDate] = useState("");
  const [appointmentToast, setAppointmentToast] = useState(null);

  const [prefilledDoctorName, setPrefilledDoctorName] = useState("");
  const [prefilledDoctorSpecialization, setPrefilledDoctorSpecialization] =
    useState("");

  const [rescheduleData, setRescheduleData] = useState(null);

useEffect(() => {
  if (location.state?.fromRescheduleView) {
    const rescheduleState = location.state.fromRescheduleView;
    setPrefilledDoctorName(rescheduleState.doctorName);
    setPrefilledDoctorSpecialization(rescheduleState.doctorSpecialization);
    setRescheduleData(rescheduleState);
    setShow(true);
  } else if (location.state?.fromFollowUpView) {
    const followUpState = location.state.fromFollowUpView;
    setPrefilledDoctorName(followUpState.doctorName);
    setPrefilledDoctorSpecialization(followUpState.doctorSpecialization);
    setRescheduleData({
      ...followUpState,
      isFollowUp: true, // 🟢 crucial flag
    });
    setShow(true);
  } else if (location.state?.fromDoctorView) {
    setPrefilledDoctorName(location.state.doctorName);
    setPrefilledDoctorSpecialization(location.state.doctorSpecialization);
    setShow(true);
  } else if (location.state?.fromCreateEvent) {
    setPrefilledDoctorName("");
    setPrefilledDoctorSpecialization("");
    setShow(true);
  }

  window.history.replaceState({}, document.title);
}, [location.state]);


  useEffect(() => {
    switch (appointmentToast){
      case "success": toast.success("Appointment Booked Successfully", {autoClose: 30000}); setAppointmentToast(null); break;
      case "updated": toast.success("Appointment Updated Successfully", {autoClose: 30000}); setAppointmentToast(null); break;
      case "exists": toast.warning("Appointment Booking Failed. There might be an existing appointment on this date"); setAppointmentToast(null); break;
      case "error": toast.error("Appointment Booking Failed. Please Try Again"); setAppointmentToast(null); break;
      default: break;
    }
  }, [appointmentToast]);

  useEffect(() => {
    if (location.state?.showModal) {
      setShow(true);
    }
  }, [location.state]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [checkInDate, setCheckInDate] = useState("");
  const [checkInTime, setCheckInTime] = useState("");
  const [visitType, setVisitType] = useState("");
  const [reasonForVisit, setReasonForVisit] = useState("");
  const [searchDeptTerm, setSearchDeptTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [isDeptFocused, setIsDeptFocused] = useState(false);
  const [appointmentOnDate, setAppointmentOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  const [searchPatientTerm, setSearchPatientTerm] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [isPatientFocused, setIsPatientFocused] = useState(false);

  const clinicUserId = localStorage.getItem("userClinicID");
  const { data, isLoading, error } = useGetdropdowndataQuery(clinicUserId);

  const doctors = data?.doctors || [];
  const patients = data?.patients || [];

  const specializations = [
    ...new Set(doctors.map((doc) => doc.specialization)),
  ].map((spec, index) => ({
    id: index + 1,
    name: spec,
  }));

  const filteredDepartments = searchDeptTerm.trim()
    ? specializations.filter((dept) =>
        dept.name.toLowerCase().startsWith(searchDeptTerm.toLowerCase())
      )
    : specializations;

  const departmentsToDisplay = filteredDepartments;

  const filteredDoctorsByDept = selectedDepartment
    ? doctors.filter((doc) => doc.specialization === selectedDepartment.name)
    : [];

  const usersToDisplay = searchTerm.trim()
    ? filteredDoctorsByDept.filter((user) =>
        user.doctorName.toLowerCase().startsWith(searchTerm.toLowerCase())
      )
    : filteredDoctorsByDept;

  const patientsToDisplay = searchPatientTerm.trim()
    ? patients.filter((p) =>
        p.patientName.toLowerCase().startsWith(searchPatientTerm.toLowerCase())
      )
    : patients;

  const [makeAppointment, { isLoading: isSubmitting }] =
    useMakeappointmentMutation();

  const handleSubmit = async () => {
    if (
      !selectedDepartment ||
      !selectedUser ||
      !selectedPatient ||
      !checkInDate ||
      !checkInTime ||
      !visitType ||
      !reasonForVisit
    ) {
      alert("Please fill all fields.");
      return;
    }

    const formattedTime = new Date(
      `1970-01-01T${checkInTime}`
    ).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const payload = {
      department: selectedDepartment.name,
      doctorName: selectedUser.doctorName,
      patientName: selectedPatient.patientName,
      dateofCheckIn: checkInDate,
      insertedDate: new Date().toISOString().split("T")[0],
      timeSlot: formattedTime,
      visitType: visitType,
      reasonForVisit: reasonForVisit,
      isActive: true,
    };

    try {
      const res = await makeAppointment(payload).unwrap();
      if (res?.result_Code === 100) {
        alert("Appointment scheduled successfully!");

        setSelectedDepartment(null);
        setSearchDeptTerm("");

        setSelectedUser(null);
        setSearchTerm("");

        setSelectedPatient(null);
        setSearchPatientTerm("");

        setCheckInDate("");
        setCheckInTime("");
        setVisitType("");
        setReasonForVisit("");

        handleClose();
      }
    } catch (err) {
      console.error("Failed to schedule appointment:", err);
      alert("Error scheduling appointment.");
    }
  };

  const [triggerAppointments, { data: appointments, isPending }] =
    useLazyGetallappointmentsQuery();
  useEffect(() => {
    triggerAppointments(clinicUserId);
  }, []);

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;

    return (
      <div className="custom-event">
        <strong>Patient: {event.title}</strong>
      </div>
    );
  };

  const events =
    appointments?.map((item) => {
      return {
        title: `${item.patientName}(${item.timeSlot})`,
        start: item.dateofCheckIn,
      };
    }) || [];

  // const getTodayDate = () => {
  //   const today = new Date();
  //   return today.toISOString().split("T")[0];
  // };

  const [
    fetchavailabledoctors,
    { data: availabledoctorsData, isFetching, erroroccur },
  ] = useLazyGetavailabledoctorsQuery();

  useEffect(() => {
    fetchavailabledoctors({ clinicUserId, selectedDate: appointmentOnDate });
  }, [appointmentOnDate]);

  const handleDateClick = (arg) => {
    setShow(true);
  };

  const [calendarevents, setCalendarEvents] = useState([]);




  return (
    <main style={{ width: "100%", height: "100%" }}>
      <div className="row">
        <div className="col-12 col-xl-8 col-xxl-8">
          <Styles />

          {/* <Eventcalendar
      responsive={{
        xsmall: {
          view: {
            calendar: { type: 'week' },
            agenda: { type: 'day' }
          }
        }
      }}
      data={[
        {
          id: 1,
          start: new Date(),
          title: "Today's event"
        },
        {
          id: 2,
          start: new Date(2025, 1, 18, 9, 0),
          end: new Date(2025, 1, 20, 13, 0),
          title: 'Multi-day event'
        }
      ]}
    /> */}

          <FullCalendar
            buttonText={{
              today: "Today",
              month: "Month",
              week: "Week",
              day: "Day",
              list: "List",
            }}
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              listPlugin,
              interactionPlugin,
            ]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
            }}
            weekends={true}
            events={events}
            displayEventTime={false}
            eventContent={renderEventContent}
            dateClick={(arg) => {
              const clickedDate = arg.dateStr;
              setAppointmentOnDate(clickedDate);

              const readable = new Date(clickedDate).toLocaleDateString(
                "en-GB",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }
              );

              setDisplayDate(readable);
            }}
            dayCellClassNames={(arg) => {
              return arg.dateStr === appointmentOnDate ? ["selected-date"] : [];
            }}
          />
        </div>

        <div
          className="col-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4"
          style={{ height: "82vh", overflowY: "auto" }}
        >
          <button
            className="gradient-button font-14 w-100"
            id="btn-new-event"
            onClick={() => {
              navigate("/AddAppointment", {
                state: {
                  showModal: true, // no prefilled data here
                  fromCreateEvent: true,
                },
              });
            }}
            style={{ backgroundColor: "#ff6168", color: "white" }}
          >
            <i class="mdi mdi-plus-circle-outline"></i> + Create New Event
          </button>
          <div className="mt-3">
            <span className="fw-semibold">
              Available Doctors for Selected Dates
            </span>
            <p className="text-muted" style={{ marginTop: "6px" }}>
              {displayDate
                ? `Selected Date: ${displayDate}`
                : "Click on a date to view"}
            </p>

            <AvailableDoctors availabledoctorsData={availabledoctorsData} />
          </div>
        </div>
        <AddAppointmentModal
          show={show}
          setShow={setShow}
          prefilledDoctorName={prefilledDoctorName}
          prefilledDoctorSpecialization={prefilledDoctorSpecialization}
          rescheduleData={rescheduleData}
          setAppointmentToast={setAppointmentToast}
        />
      </div>
      <ToastContainer />
    </main>
  );
}

const Styles = () => {
  return (
    <style>
      {`
      .fc .selected-date {
        background-color:rgb(206, 169, 58) !important;
        border-radius: 6px;
        cursor: pointer;
        transition: background-color 0.3s ease;
      }

      .fc .fc-daygrid-day:hover {
        background-color:#00000026;
        cursor: pointer;
      }
      `}
    </style>
  );
};

export default AddAppointment;
